import {UserOPEEnum} from "./UserOPEEnum";
import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";


class O {
  id!: number;
  welcomeSent!: boolean;
}

/**
 * O Inner Class
 */
class I {
  id?: number;
  username!: string;
  email!: string;
  password?: string;
  language?: string;
  firstname!: string;
  lastname!: string;
  roles!: string[];
  partitionId?: number;
  enabled!: boolean;
  welcomeSent!: boolean;
  linkedPartitions?: number[];
}

class RoleDTO {
  /**
   * Role name
   */
  name!: string;

  /**
   * Role priority
   */
  priority!: number;
}


/**
 * GetTransportItemDetailCB class
 */
export class PutUserCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(UserOPEEnum.PutUser);
    this.i = new I();
    this.o = new O();
  }

}
